export default {
  computed: {
    unreadNotifications() {
      if (!this.getNotifications) return 0;

      let count = 0;
      for (const notification of this.getNotifications) {
        if (notification?.read === false) {
          count++;
        }
      }
      return count;
    }
  }
};
